import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { setViewCreatePostModal, postCreateReset } from 'features/posts/postSlice'
import { useDispatch, useSelector } from 'react-redux'
import FormTop from 'components/createPostModal/FormTop'
import CreatePostFormData from './CreatePostFormData'
import ModalCloseButton from 'components/buttons/ModalCloseButton'

import { useTranslation } from 'react-i18next'

export default function CreatePostModal() {
  const { t: translate } = useTranslation()
    const dispatch = useDispatch()
    const { isPostCreatedSuccess } = useSelector((state) => state.posts)
    const { user } = useSelector((state) => state.auth)

    useEffect(() => {
        if (isPostCreatedSuccess) {
            dispatch(setViewCreatePostModal(false))
            dispatch(postCreateReset())
        }
    }, [isPostCreatedSuccess])

    return (
        <Modal>
            <ModalCloseButton
                handler={() => dispatch(setViewCreatePostModal(false))}
                size="32px"
                top="12px"
                right="12px"
            />

            <Header>
                <Title>{translate("web:general.createPost")}</Title>
            </Header>

            <Divider />

            <FormTop />
            <CreatePostFormData />
        </Modal>
    )
}

const Modal = styled.div`
    background: #fff;
    width: 945px;
    max-width: 96vw;
    max-height: 90vh;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow-y: auto;
    box-shadow: 0 8px 40px rgba(0,0,0,0.14);

    @media (max-width: 768px) {
        width: 100%;
        border-radius: 14px 14px 0 0;
    }
`

const Header = styled.div`
    padding: 18px 20px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const Title = styled.h2`
    font-size: 16px;
    font-weight: 700;
    color: var(--lightThemeFontColor);
    margin: 0;
`

const Divider = styled.div`
    height: 1px;
    background-color: #f0f0f0;
    width: 100%;
`
